import {getTimeZone} from "_helpers";
import * as moment from 'moment-timezone';
import {channelTypes} from "_constants";

export const proactiveCriteriaOptions = {
    retain: [
        { "name": "all_messages", "value": "All messages" },
        { "name": "replied", "value": "Replied" },
        { "name": "converted", "value": "Converted" },
        { "name": "followUpSent", "value": "Follow Up Sent" },
        { "name": "convertedAfterFollowUpSent", "value": "Converted After Follow Up" }
    ],
    acquire: [
        { "name": "all_messages", "value": "All messages" },
        { "name": "replied", "value": "Replied" },
        { "name": "liked", "value": "Liked" },
        { "name": "noEngagementYet", "value": "No Engagement Yet" },
        { "name": "followed", "value": "Followed" }
    ]
};

export function formatDateCreated(date, format) {
    const timezone = getTimeZone();
    return `${moment.tz(date, timezone).format(format)}`
}

export const isShopifyAndFirstIncomingMessage = (messageSource, isFirstIncomingMessaging) => {
    const isSourceShopify = messageSource?.toUpperCase() === channelTypes.shopify
    return isSourceShopify && isFirstIncomingMessaging
}